import { render, staticRenderFns } from "./BaseMultiSelect.vue?vue&type=template&id=304c5159&scoped=true"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseMultiSelect.vue?vue&type=style&index=0&id=304c5159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304c5159",
  null
  
)

export default component.exports